// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductConfigureForm_container__HVEfa"};